'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
export function useSliderPosition(sliderRef) {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const animationRef = useRef(null);
  const updateSliderPosition = useCallback(pointerX => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }
    animationRef.current = requestAnimationFrame(() => {
      if (!sliderRef.current) return;
      const rect = sliderRef.current.getBoundingClientRect();
      const x = pointerX - rect.left;
      const percentage = Math.max(0, Math.min(100, x / rect.width * 100));
      setSliderPosition(percentage);
    });
  }, []);
  useEffect(() => {
    if (!isDragging) return;
    const handleMouseMove = event => {
      updateSliderPosition(event.clientX);
    };
    const handleTouchMove = event_0 => {
      if (event_0.touches.length > 0) {
        updateSliderPosition(event_0.touches[0].clientX);
      }
    };
    const handleStopDragging = () => {
      setIsDragging(false);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchmove', handleTouchMove, {
      passive: true
    });
    document.addEventListener('mouseup', handleStopDragging);
    document.addEventListener('touchend', handleStopDragging);
    document.body.style.userSelect = 'none';
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('mouseup', handleStopDragging);
      document.removeEventListener('touchend', handleStopDragging);
      document.body.style.userSelect = '';
    };
  }, [isDragging, updateSliderPosition]);
  return {
    sliderPosition,
    setSliderPosition,
    isDragging,
    setIsDragging
  };
}